export const QUERY__CATEGORIES = 'categories';
export const QUERY__SUB_CATEGORIES = 'sub-categories-of-category';
export const QUERY__CATEGORY = 'category';
